import "../../../static/js/loaders/jquery";

$('.diva-block h3').addClass('heading-level-3');